module.exports = __webpack_public_path__ + "img/Image_tertarik.e42f9e86.png";